import closeIcon from "assets/icons/close.svg";
import infoIcon from "assets/icons/info.svg";
import Emails from "components/ShareDocuments/Emails";
import React from 'react';
import "./index.scss";
const ShareDocumentsHeader = ({
  savedEmails,
  setSavedEmails,
  closeModal,
  title,
  isMultiple,
}) => {
  return (
    <div className="share-documents__content__header">
      <div className="share-documents__content__header-title">
        <h2>{title}</h2>
        {!isMultiple && (<img src={infoIcon} alt="info" />)}
      </div>
      {!isMultiple && (
        <Emails
          setSavedEmails={setSavedEmails}
          savedEmails={savedEmails}
        />
      )}
      <div className="share-documents-close"
        onClick={() => closeModal()}
      >
        <img src={closeIcon} alt="" />
      </div>
    </div>
  )
}

export default ShareDocumentsHeader